// extracted by mini-css-extract-plugin
module.exports = {"FullPagePicture":"style_FullPagePicture__1P1iW"};